<div class="container">
    <div class="header">
        <h5 class="title">
            {{ 'duty-engineer.edit-categories.dialog.title' | translate }}
        </h5>
        <div class="buttons-container">
            <div class="cancel button" (click)="cancelClick()">
                {{ 'shipyard.create.dialog.form.button.cancel' | translate }}
            </div>
            <div
                class="save button"
                data-cy="ops-settings-duty-engrs-categories-save-button"
                [class.disabled]="!isModified"
                (click)="isModified && saveClick()">
                {{ 'duty-engineer.edit-categories.dialog.save' | translate }}
            </div>
        </div>
    </div>

    <div class="table-header">
        <div class="category-info">
            {{
                'duty-engineer.edit-categories.dialog.category-range'
                    | translate
                        : {
                              rangeLabel: categoryRangeLabel,
                              total: data.channelCategories.length,
                          }
            }}
        </div>
        <div class="navigation-icons">
            <mat-icon
                svgIcon="arrow-circle-left"
                [ngClass]="{ active: currentPage > 0 }"
                (click)="prevPage()"></mat-icon>
            <mat-icon
                svgIcon="arrow-circle-right"
                [ngClass]="{
                    active: (currentPage + 1) * pageSize < data.channelCategories.length,
                }"
                (click)="nextPage()"></mat-icon>
        </div>
    </div>

    <div class="table-wrapper">
        <table>
            <thead>
                <tr>
                    <th class="engineer-col">
                        {{ 'duty-engineer.edit-categories.dialog.engineer.list' | translate }}
                    </th>
                    <th [attr.colspan]="pagedCategories.length" class="categories-col">
                        {{ 'duty-engineer.edit-categories.dialog.categories' | translate }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let engineer of data.engineerList">
                    <td class="engineer-name-cell" data-cy="ops-settings-duty-engrs-categories-engr-name">
                        {{ engineer.name }}
                    </td>
                    <td *ngFor="let category of pagedCategories" class="category-cell" [class.empty-cell]="!category">
                        <mat-checkbox
                            data-cy="ops-settings-duty-engrs-categories-checkbox"
                            *ngIf="category"
                            [(ngModel)]="assignments[engineer.id][category.id]"
                            (change)="markAsModified()">
                            {{ category.category }}
                        </mat-checkbox>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>
